import { $ } from '../utils/Utils';

const imgLoader = (() => {
  const triggerCN = 'js-imgLoadTrigger';
  const imgLoadedCN = 'loaded';

  const build = () => {
    [...$(`.${triggerCN}`)].forEach((trigger, i) => {
      trigger.classList.remove(triggerCN);

      const img = new Image();

      img.onload = () => {
        img.classList.add(imgLoadedCN);

        setTimeout(() => {
          trigger.appendChild(img);
        }, 100 * i);
      };

      img.src = trigger.dataset.href;
    });
  };

  const init = () => {
    if ($(`.${triggerCN}`).length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

imgLoader.init();

export default imgLoader;



// WEBPACK FOOTER //
// ./components/img-loader.js